import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { BrokerTransactionApprovalService } from '../broker-transaction-approval.service';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { ApproveActionTypeModel } from '../../../model/approveActionTypeModel';
import { SubmitTransactionApprovalRequestModel } from '../../../model/submitTransactionApprovalRequestModel';
import { Subscription } from 'rxjs';
import { SubmitTransactionApprovalResponseModel } from '../../../model/submitTransactionApprovalResponseModel';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { MessageModel } from '../../../model/models';
import { SpinnerService } from '../../../shared/spinner/spinner.service';
import { CompleteFunctionService } from '../../../shared/utils/complete-function.service';
import { CompleteFunctionRequestModel } from '../../../model/completeFunctionRequestModel';
import { CompleteFunctionResponseModel } from '../../../model/completeFunctionResponseModel';
import { Router } from '@angular/router';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import { TransactionsService } from '../../../transactions/transactions.service';
import * as $ from 'jquery';
import { StorageService } from '../../../shared/security/StorageService';
import { WorkflowModel } from '../../../model/workflowModel';
import { IndividualLicenseComponent } from '../individual-license/individual-license.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-broker-submit-pending-approvals',
  templateUrl: './broker-submit-pending-approvals.component.html',
  styleUrls: ['./broker-submit-pending-approvals.component.css']
})
export class BrokerSubmitPendingApprovalsComponent implements OnInit, OnDestroy {

  approvalsToConfirm: Array<ApproveActionTypeModel> = [];
  submitTransactionApprovalRequestModel: SubmitTransactionApprovalRequestModel = new SubmitTransactionApprovalRequestModel();
  startFunction: StartFunctionResponseModel = {};
  userMessages: Array<MessageModel> = [];
  confirmationNumber: string = null;
  now: Date = new Date();
  workflow: WorkflowModel = new WorkflowModel();


  notifyPendingTransactionsListSubscription = new Subscription();
  notifySubmitTransactionApprovalResponseModelSubscription = new Subscription();

  constructor(private brokerTranApprovalService: BrokerTransactionApprovalService,
    private startFunctionService: StartFunctionService,
    private spinner: SpinnerService,
    private completeFunctionService: CompleteFunctionService,
    private router: Router,
    private currentPageWatcher: CurrentPageWatcherService,
    private storageService: StorageService,
    private modalService: NgbModal) {

    this.startFunction = this.storageService.getStartFunctionData();
    this.workflow = this.startFunction.Workflow;
    // if (this.startFunction != null && this.startFunction != undefined && this.startFunction.Workflow != null) {
    //   this.startFunctionService.sendStartFunctionBrokerResp(this.startFunction);
    // }
    this.notifyPendingTransactionsListSubscription = this.brokerTranApprovalService.getNotifyPendingTransactionsList().subscribe(
      data => {
        this.approvalsToConfirm = data;
      }
    );


    this.notifySubmitTransactionApprovalResponseModelSubscription = this.brokerTranApprovalService.getNotifySubmitTransactionApprovalResponseModel().subscribe(
      data => {
        this.submitTransactionApprovalRequestModel = data;
      }
    );
  }

  open(indivID: number){
    const modalRef = this.modalService.open(IndividualLicenseComponent);
    modalRef.componentInstance.indivID = indivID;
  }

  ngOnInit() {
  }


  onConfirmSubmit() {
    this.currentPageWatcher.clearUserMessage();
    //Submit transactions for approval/disapproval
    this.brokerTranApprovalService.submitBrokerTransaction(this.submitTransactionApprovalRequestModel).subscribe(
      (submitResp: SubmitTransactionApprovalResponseModel) => {
        console.log("submit trans approval response ", submitResp);
        submitResp.UserMessages.forEach(el => this.userMessages.push(el));
        this.currentPageWatcher.sendUserMessages(this.userMessages);
        if (submitResp.Summary == 0) {
          //complete function
          this.completeFunction(submitResp);
          this.userMessages = [];
        }
        if (submitResp.Summary == 1) {
          $("html, body").animate({ scrollTop: 0 }, "slow");
          this.userMessages = [];
        }
        if (submitResp.Summary == 2) {
          this.router.navigate(["/home"]);
          this.userMessages = [];
        }
      },
      err => {
        this.handleBrokerError(err)
      }


    );
  }

  completeFunction(submitTransactionResp: SubmitTransactionApprovalResponseModel) {
    this.currentPageWatcher.sendUserMessages(null);
    let completeFunctionRequest: CompleteFunctionRequestModel = new CompleteFunctionRequestModel();
    completeFunctionRequest.WorkflowID = submitTransactionResp.Workflow.WorkflowID;
    completeFunctionRequest.CurrentStepIndex = submitTransactionResp.Workflow.CurrentStepIndex;
    completeFunctionRequest.OrderNumber = null;
    this.completeFunctionService.completeFunction(completeFunctionRequest).subscribe(
      (completeFuncResp: CompleteFunctionResponseModel) => {
        console.log("complete function resp: ", completeFuncResp);
        completeFuncResp.UserMessages.forEach(el => {
            this.userMessages.push(el);
        });
        this.currentPageWatcher.sendUserMessages(this.userMessages);
        if (completeFuncResp.Summary == 0) {
          this.confirmationNumber = completeFuncResp.ConfirmationNumber;
          this.startFunctionService.getNotifyStepInProgress().emit(true);
          this.userMessages = [];
        }
        if (completeFuncResp.Summary == 1){
          $("html, body").animate({ scrollTop: 0 }, "slow");
          this.userMessages = [];
        }
        if (completeFuncResp.Summary == 2) {
          this.router.navigate(["/home"]);
          this.userMessages = [];
        }
      },
      err => {
        this.handleBrokerError(err)
      }
    )
  }

  handleBrokerError(err) {

    if (err.error && err.error.UserMessages != undefined) {
      err.error.UserMessages.forEach(element => {
        this.userMessages.push(element)
      });
    }
    else {
      let userMsg: MessageModel;
      userMsg.Alert = 3;
      userMsg.Description = err.message;
      this.userMessages.push(userMsg);
    }
    $("html, body").animate({ scrollTop: 0 }, "slow");
    this.currentPageWatcher.sendUserMessages(this.userMessages);
    this.spinner.hide();
    this.userMessages=[];
  }
  back() {
    this.router.navigate(["/pendingApprovals"])
    .then(()=>{
      this.currentPageWatcher.sendUserMessages(null);
      this.startFunctionService.getNotifyStepInProgress().emit(false);
    });
   
  }

  returnToHome() {
    this.router.navigate(["/home"]).then(()=>{
      this.currentPageWatcher.sendUserMessages(null);
    });
  }

  ngOnDestroy(): void {
  //  this.currentPageWatcher.clearUserMessage();
    this.currentPageWatcher.clearUserMessage();
    this.currentPageWatcher.clearStepMessage();
  }
  
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.back();
  }

  printPage(){
    window.print();
  }
}



// WEBPACK FOOTER //
// ./src/app/broker/view-pending-approvals/broker-submit-pending-approvals/broker-submit-pending-approvals.component.ts